import { render, staticRenderFns } from "./TeacherAwayAssignment.vue?vue&type=template&id=51a57f33&scoped=true&"
import script from "./TeacherAwayAssignment.vue?vue&type=script&lang=js&"
export * from "./TeacherAwayAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a57f33",
  null
  
)

export default component.exports